/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TopCostOptimizationWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("TopCostOptimizationWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return TopCostOptimizationWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<TopCostOptimizationWidgetConfiguration>): TopCostOptimizationWidgetConfiguration {
        let obj = Object.assign(new TopCostOptimizationWidgetConfiguration(), model);
        TopCostOptimizationWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TopCostOptimizationWidgetConfiguration>): TopCostOptimizationWidgetConfiguration {
        if (!model) return null;
        return TopCostOptimizationWidgetConfiguration.newInstance(<TopCostOptimizationWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TopCostOptimizationWidgetConfiguration) {
        if (!obj) return;

        models.TopCostOptimizationWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TopCostOptimizationWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TopCostOptimizationWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of Optimization
     */
    optimizationSelection: models.OptimizationSelection;

}
